// URL
export enum URL {
  APP = 'https://app.perpetua.io/',
  Login = 'https://app.perpetua.io/login',
  SignUp = 'https://app.perpetua.io/signup',
  Privacy = 'https://perpetua.io/privacy/',
  Tos = 'https://perpetua.io/tos/',
  Agency = '/agencies',
  Video = 'https://app.perpetua.io/brands/add/video/?openvideocreator=true',
  Demo = '/demo/',
  BenchMarker = 'https://perpetua.io/amazon-advertising-benchmark-tool/',
  Gmail = 'https://mail.google.com/mail/',
}

export enum Intercom {
  Open = 'intercom',
}

export enum Hubspot {
  portalId = '48751911',
  demoFormId_DE = '86248fd0-c6cb-4ff5-bfb6-2630a22fadc3',
  demoFormId_EN = 'f2ee5ea3-8f61-4aaa-827b-8985d2ebe3b6',
  BIformId = '9acd6d06-de38-49ef-82d8-d64634880918',
  signupEmailFormId = '8458ad2e-98ba-42c2-b370-6ff842c47383',
  newAccountFormId = '8f8ef6ab-1075-445f-a4cf-648e8af83b99',
  existingAccountFormId = 'd7135757-aaf8-4426-b453-0d086bbc4643',
  AMAZON_ACCELERATOR_PROGRAM_FORM_ID = '1ef8ea34-0eac-41fb-bf92-17858ee285e5',
  WEBINAR_FORM_ID = '5c55cc73-14a0-4da3-9dee-964e9a7a898c',
  WEBINAR_ON_DEMAND_FORM_ID = 'a9748845-2d94-4c1a-9270-bde6976b2901',
  PRISM_FORM_ID = '72bcd5a8-f5c0-4bcb-b931-68da66cbe8ba',
  NEWSLETTER_EN = '9e295ecf-6797-4cd0-ae36-9f4328c0de9a',
  NEWSLETTER_DE = '1a996111-53ac-4365-90f9-1f9432eaa2c5',
  STARTUP_FORM_ID = 'dbb3fa8f-1a25-4552-9366-01a1721e34c8',
  RESOURCES_DEFAULT_UPPER_FUNNEL_FORM_ID = '1e2fce46-3c67-4434-aeef-e7e620e39377',
  RESOURCES_DEFAULT_LOWER_FUNNEL_FORM_ID = 'd80bca22-ff82-4cbe-baca-7465ecc8b2ac',
}

export enum HubspotSubscription {
  oneToOne = 537001062,
  product = 537001061,
  events = 681717673
}

export enum SOCIAL_LINKS {
  Instagram = 'https://www.instagram.com/perpetua.io/',
  TikTok = 'https://www.tiktok.com/@perpetua.io',
  YouTube = 'https://www.youtube.com/channel/UCVPWE5c8kRN6QOcp8ntIbTw',
  LinkedIn = 'https://www.linkedin.com/company/perpetua-labs/',
  Facebook = 'https://www.facebook.com/perpetualabs/',
  Twitter = 'https://twitter.com/PerpetuaLabs',
}

export enum PlatformRoute {
  amazon = 'am',
  instacart = 'ic',
  target = 'tg',
  walmart = 'wm',
  criteo = 'cr',
}
